import {
  ADD_CANDIDATE,
  ADD_CANDIDATE_FAILED,
  ADD_CANDIDATE_SUCCESS,
  CLOSE_JOB,
  CLOSE_JOB_FAILED,
  CLOSE_JOB_SUCCESS,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS,
  DELETE_MAPPED_JOB_CANDIDATE,
  DELETE_MAPPED_JOB_CANDIDATE_ERROR,
  DELETE_MAPPED_JOB_CANDIDATE_SUCCESS,
  EXTEND_JOB,
  EXTEND_JOB_FAILED,
  EXTEND_JOB_SUCCESS,
  GET_MAPPED_JOB_CANDIDATE_DETAIL,
  GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
  GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
  GET_MATCHED_CANDIDATE_DETAIL,
  GET_MATCHED_CANDIDATE_DETAIL_ERROR,
  GET_MATCHED_CANDIDATE_DETAIL_SUCCESS,
  GET_MATCHING_CANDIDATE,
  GET_MATCHING_CANDIDATE_ERROR,
  GET_MATCHING_CANDIDATE_SUCCESS,
  GET_MATCHING_JOB_BOARD_CANDIDATE,
  GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS,
  GET_SELECTED_JOB_DETAIL,
  GET_SELECTED_JOB_DETAIL_ERROR,
  GET_SELECTED_JOB_DETAIL_SUCCESS,
  GET_SIMILAR_JOB_DETAIL,
  GET_SIMILAR_JOB_DETAIL_ERROR,
  GET_SIMILAR_JOB_DETAIL_SUCCESS,
  GOOGLE_JOB_DETAILS,
  GOOGLE_JOB_DETAILS_FAILED,
  GOOGLE_JOB_DETAILS_SUCCESS,
  JOB_LISTING_SUGGESTIONS,
  JOB_LISTING_SUGGESTIONS_FAILED,
  JOB_LISTING_SUGGESTIONS_SUCCESS,
  JOB_STATUS,
  JOB_STATUS_FAILED,
  JOB_STATUS_SUCCESS,
  OTHER_JOB_DETAILS,
  OTHER_JOB_DETAILS_FAILED,
  OTHER_JOB_DETAILS_SUCCESS,
  POST_POPUP_DATA,
  POST_POPUP_DATA_FAIL,
  POST_POPUP_DATA_SUCCESS,
  SEND_CANDIDATE_INTEREST_REMINDER,
  SEND_CANDIDATE_INTEREST_REMINDER_FAILED,
  SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS,
  SET_MAPPED_JOB_CANDIDATE_DETAIL,
  SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
  SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
  UPDATE_MAPPED_CANDIDATE,
  UPDATE_MAPPED_CANDIDATE_ERROR,
  UPDATE_MAPPED_CANDIDATE_SUCCESS,
  VIEW_JOB,
  VIEW_JOB_ERROR,
  VIEW_JOB_SUCCESS,
  GENERATE_MATCHING_SCORE,
  GENERATE_MATCHING_SCORE_SUCCESS,
  GENERATE_MATCHING_SCORE_ERROR,
  GET_DEFAULT_WEIGHTAGE,
  GET_DEFAULT_WEIGHTAGE_SUCCESS,
  GET_DEFAULT_WEIGHTAGE_ERROR,
  GET_CUSTOM_WEIGHTAGE,
  GET_CUSTOM_WEIGHTAGE_SUCCESS,
  GET_CUSTOM_WEIGHTAGE_ERROR,
  SAVE_CUSTOM_WEIGHTAGE,
  SAVE_CUSTOM_WEIGHTAGE_SUCCESS,
  SAVE_CUSTOM_WEIGHTAGE_ERROR,
  GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR,
  GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS,
  GET_FILTERED_JOB_BOARD_CANDIDATES,
  GET_CANDIDATE_FACETS_ERROR,
  GET_CANDIDATE_FACETS_SUCCESS,
  GET_CANDIDATE_FACETS,
  GENERATE_BULK_MATCHING_SCORE,
  GENERATE_BULK_MATCHING_SCORE_SUCCESS,
  GENERATE_BULK_MATCHING_SCORE_ERROR,
  GET_JOB_BASED_FACETS,
  GET_JOB_BASED_FACETS_SUCCESS,
  GET_JOB_BASED_FACETS_ERROR,
  BULK_MAP_CANDIDATES_TO_JOB,
  BULK_MAP_CANDIDATES_TO_JOB_SUCCESS,
  BULK_MAP_CANDIDATES_TO_JOB_ERROR,
} from "./actionTypes";

// view jobs
export const getviewJobDetails = (viewJob) => {
  return {
    type: VIEW_JOB,
    payload: { viewJob },
  };
};
export const getviewJobDetailsSuccess = (viewJob) => {
  return {
    type: VIEW_JOB_SUCCESS,
    payload: { viewJob },
  };
};
export const getviewJobDetailsFailed = (viewJob) => {
  return {
    type: VIEW_JOB_ERROR,
    payload: { viewJob },
  };
};
// matching candidate
export const getMatchingCandidate = (matchingCandidate) => {
  return {
    type: GET_MATCHING_CANDIDATE,
    payload: { matchingCandidate },
  };
};
//jobportal matching candidates
export const getMatchingJobBoardCandidate = (matchingCandidate) => {
  return {
    type: GET_MATCHING_JOB_BOARD_CANDIDATE,
    payload: { matchingCandidate },
  };
};
export const getMatchingCandidateSuccess = (matchingCandidate) => {
  return {
    type: GET_MATCHING_CANDIDATE_SUCCESS,
    payload: { matchingCandidate },
  };
};
export const getMatchingJobBoardCandidateSuccess = (matchingCandidate) => {
  return {
    type: GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS,
    payload: { matchingCandidate },
  };
};
export const getMatchingCandidateFailed = (matchingCandidate) => {
  return {
    type: GET_MATCHING_CANDIDATE_ERROR,
    payload: { matchingCandidate },
  };
};
// matching candidate
export const getMatchedCandidateDetail = (matchedCandidateDetail) => {
  return {
    type: GET_MATCHED_CANDIDATE_DETAIL,
    payload: { matchedCandidateDetail },
  };
};
export const getMatchedCandidateDetailSuccess = (matchedCandidateDetail) => {
  return {
    type: GET_MATCHED_CANDIDATE_DETAIL_SUCCESS,
    payload: { matchedCandidateDetail },
  };
};
export const getMatchedCandidateDetailFailed = (matchedCandidateDetail) => {
  return {
    type: GET_MATCHED_CANDIDATE_DETAIL_ERROR,
    payload: { matchedCandidateDetail },
  };
};
// similar jobs
export const getSimilarJobsDetails = (similarJob, page) => {
  return {
    type: GET_SIMILAR_JOB_DETAIL,
    payload: { similarJob, page },
  };
};
export const getSimilarJobsDetailsSuccess = (similarJob) => {
  return {
    type: GET_SIMILAR_JOB_DETAIL_SUCCESS,
    payload: { similarJob },
  };
};
export const getSimilarJobsDetailsFailed = (similarJob) => {
  return {
    type: GET_SIMILAR_JOB_DETAIL_ERROR,
    payload: { similarJob },
  };
};
// similar selected job
export const getSimilarSelectedJobsDetails = (selectedJob) => {
  return {
    type: GET_SELECTED_JOB_DETAIL,
    payload: { selectedJob },
  };
};
export const getSimilarSelectedJobsDetailsSuccess = (selectedJob) => {
  return {
    type: GET_SELECTED_JOB_DETAIL_SUCCESS,
    payload: { selectedJob },
  };
};
export const getSimilarSelectedJobsDetailsFailed = (selectedJob) => {
  return {
    type: GET_SELECTED_JOB_DETAIL_ERROR,
    payload: { selectedJob },
  };
};
// mapped candidates job
export const getMappedCandidateJob = (
  mappedCandidate,
  mappedCandidateType,
  page,
  pageSize,
  keyboard,
  sort,
) => {
  return {
    type: GET_MAPPED_JOB_CANDIDATE_DETAIL,
    payload: {
      mappedCandidate,
      mappedCandidateType,
      page,
      pageSize,
      keyboard,
      sort,
    },
  };
};
export const getMappedCandidateJobSuccess = (mappedCandidate) => {
  return {
    type: GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
    payload: { mappedCandidate },
  };
};
export const getMappedCandidateJobFailed = (mappedCandidate) => {
  return {
    type: GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
    payload: { mappedCandidate },
  };
};
// delete mapped candidates job
export const deleteMappedCandidate = (data) => {
  return {
    type: DELETE_MAPPED_JOB_CANDIDATE,
    payload: { deleteMappedCandidate: data },
  };
};
export const deleteMappedCandidateSuccess = (data) => {
  return {
    type: DELETE_MAPPED_JOB_CANDIDATE_SUCCESS,
    payload: data,
  };
};
export const deleteMappedCandidateFailed = (data) => {
  return {
    type: DELETE_MAPPED_JOB_CANDIDATE_ERROR,
    payload: data,
  };
};
// set mapped candidates job
export const setMappedCandidateJob = (setMappedCandidate) => {
  return {
    type: SET_MAPPED_JOB_CANDIDATE_DETAIL,
    payload: { setMappedCandidate },
  };
};
export const setMappedCandidateJobSuccess = (setMappedCandidate) => {
  return {
    type: SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
    payload: { setMappedCandidate },
  };
};
export const setMappedCandidateJobFailed = (setMappedCandidate) => {
  return {
    type: SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
    payload: { setMappedCandidate },
  };
};

// Bulk map candidates to job
export const bulkMapCandidatesToJob = (data) => {
  return {
    type: BULK_MAP_CANDIDATES_TO_JOB,
    payload: data,
  };
};
export const bulkMapCandidatesToJobSuccess = (data) => {
  return {
    type: BULK_MAP_CANDIDATES_TO_JOB_SUCCESS,
    payload: data,
  };
};
export const bulkMapCandidatesToJobError = (error) => {
  return {
    type: BULK_MAP_CANDIDATES_TO_JOB_ERROR,
    payload: error,
  };
};

// update mapped candidates Status
export const updateMappedCandidate = (data) => {
  return {
    type: UPDATE_MAPPED_CANDIDATE,
    payload: { updateMappedCandidate: data },
  };
};
export const updateMappedCandidateSuccess = (data) => {
  return {
    type: UPDATE_MAPPED_CANDIDATE_SUCCESS,
    payload: { updateMappedCandidate: data },
  };
};

export const updateMappedCandidateFailed = (data) => {
  return {
    type: UPDATE_MAPPED_CANDIDATE_ERROR,
    payload: { updateMappedCandidate: data },
  };
};

export const extendJob = (data) => {
  return {
    type: EXTEND_JOB,
    payload: data,
  };
};

export const extendJobSuccess = (data) => {
  return {
    type: EXTEND_JOB_SUCCESS,
    payload: data,
  };
};

export const extendJobFailed = (error) => {
  return {
    type: EXTEND_JOB_FAILED,
    payload: error,
  };
};

export const closeJob = (data) => {
  return {
    type: CLOSE_JOB,
    payload: data,
  };
};

export const closeJobSuccess = (data) => {
  return {
    type: CLOSE_JOB_SUCCESS,
    payload: data,
  };
};

export const closeJobFailed = (error) => {
  return {
    type: CLOSE_JOB_FAILED,
    payload: error,
  };
};

export const otherJobDetails = (id) => {
  return {
    type: OTHER_JOB_DETAILS,
    payload: id,
  };
};

export const otherJobDetailsSuccess = (details) => {
  return {
    type: OTHER_JOB_DETAILS_SUCCESS,
    payload: details,
  };
};

export const otherJobDetailsFailed = (error) => {
  return {
    type: OTHER_JOB_DETAILS_FAILED,
    payload: error,
  };
};

// Google jobs

export const googleJobDetails = (id) => {
  return {
    type: GOOGLE_JOB_DETAILS,
    payload: id,
  };
};

export const googleJobDetailsSuccess = (GoogleJobdetails) => {
  return {
    type: GOOGLE_JOB_DETAILS_SUCCESS,
    payload: GoogleJobdetails,
  };
};

export const googleJobDetailsFailed = (error) => {
  return {
    type: GOOGLE_JOB_DETAILS_FAILED,
    payload: error,
  };
};

export const addCandidate = (details) => {
  return {
    type: ADD_CANDIDATE,
    payload: details,
  };
};

export const addCandidateSuccess = (message) => {
  return {
    type: ADD_CANDIDATE_SUCCESS,
    payload: message,
  };
};

export const addCandidateFailure = (error) => {
  return {
    type: ADD_CANDIDATE_FAILED,
    payload: error,
  };
};

//send reminder
export const sendCandidateReminder = (data) => {
  return {
    type: SEND_CANDIDATE_INTEREST_REMINDER,
    payload: data,
  };
};

export const sendCandidateReminderSuccess = (message) => {
  return {
    type: SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS,
    payload: message,
  };
};

export const sendCandidateReminderFail = (error) => {
  return {
    type: SEND_CANDIDATE_INTEREST_REMINDER_FAILED,
    payload: error,
  };
};
// job suggestions
export const suggestionApi = (details) => {
  return {
    type: JOB_LISTING_SUGGESTIONS,
    payload: details,
  };
};

export const suggestionApiSuccess = (details) => {
  return {
    type: JOB_LISTING_SUGGESTIONS_SUCCESS,
    payload: details,
  };
};

export const suggestionApiFailed = (error) => {
  return {
    type: JOB_LISTING_SUGGESTIONS_FAILED,
    payload: error,
  };
};

// job status
export const jobStatus = (details) => {
  return {
    type: JOB_STATUS,
    payload: details,
  };
};

export const jobStatusSuccess = (details) => {
  return {
    type: JOB_STATUS_SUCCESS,
    payload: details,
  };
};

export const jobStatusFailed = (error) => {
  return {
    type: JOB_STATUS_FAILED,
    payload: error,
  };
};

//modal popup

export const postPopupData = (details) => {
  return {
    type: POST_POPUP_DATA,
    payload: details,
  };
};

export const postPopupDataSuccess = (details) => {
  return {
    type: POST_POPUP_DATA_SUCCESS,
    payload: details,
  };
};

export const postPopupDataFailed = (error) => {
  return {
    type: POST_POPUP_DATA_FAIL,
    payload: error,
  };
};

export const candidateDelete = (data) => {
  return {
    type: DELETE_CANDIDATE_ON_CANDIDATEPOOL,
    payload: data,
  };
};

export const candidateDeleteSuccess = (data) => {
  return {
    type: DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS,
    payload: data,
  };
};

export const candidateDeleteFailed = (error) => {
  return {
    type: DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED,
    payload: error,
  };
};

// Generate Matching Score
export const generateMatchingScore = (data) => ({
  type: GENERATE_MATCHING_SCORE,
  payload: data,
});

export const generateMatchingScoreSuccess = (data) => ({
  type: GENERATE_MATCHING_SCORE_SUCCESS,
  payload: data,
});

export const generateMatchingScoreError = (error) => ({
  type: GENERATE_MATCHING_SCORE_ERROR,
  payload: error,
});

// Default Weightage
export const getDefaultWeightage = () => ({ type: GET_DEFAULT_WEIGHTAGE });
export const getDefaultWeightageSuccess = (data) => ({
  type: GET_DEFAULT_WEIGHTAGE_SUCCESS,
  payload: data,
});
export const getDefaultWeightageError = (error) => ({
  type: GET_DEFAULT_WEIGHTAGE_ERROR,
  payload: error,
});

// Custom Weightage (fetch)
export const getCustomWeightage = (jobId) => ({
  type: GET_CUSTOM_WEIGHTAGE,
  payload: jobId,
});
export const getCustomWeightageSuccess = (data) => ({
  type: GET_CUSTOM_WEIGHTAGE_SUCCESS,
  payload: data,
});
export const getCustomWeightageError = (error) => ({
  type: GET_CUSTOM_WEIGHTAGE_ERROR,
  payload: error,
});

// Save Custom Weightage
export const saveCustomWeightage = (data) => ({
  type: SAVE_CUSTOM_WEIGHTAGE,
  payload: data,
});
export const saveCustomWeightageSuccess = (data) => ({
  type: SAVE_CUSTOM_WEIGHTAGE_SUCCESS,
  payload: data,
});
export const saveCustomWeightageError = (error) => ({
  type: SAVE_CUSTOM_WEIGHTAGE_ERROR,
  payload: error,
});

// Get Candidate Facets (Filter Options)
export const getCandidateFacets = (jobId) => {
  return {
    type: GET_CANDIDATE_FACETS,
    payload: { jobId },
  };
};

export const getCandidateFacetsSuccess = (facets) => {
  return {
    type: GET_CANDIDATE_FACETS_SUCCESS,
    payload: { facets },
  };
};

export const getCandidateFacetsError = (error) => {
  return {
    type: GET_CANDIDATE_FACETS_ERROR,
    payload: { error },
  };
};

// Get Job-Based Facets (for Recommended Candidates tab)
export const getJobBasedFacets = (jobId) => {
  return {
    type: GET_JOB_BASED_FACETS,
    payload: { jobId },
  };
};

export const getJobBasedFacetsSuccess = (facets) => {
  return {
    type: GET_JOB_BASED_FACETS_SUCCESS,
    payload: { facets },
  };
};

export const getJobBasedFacetsError = (error) => {
  return {
    type: GET_JOB_BASED_FACETS_ERROR,
    payload: { error },
  };
};

// Get Filtered Job Portal Candidates
export const getFilteredJobPortalCandidates = (filters) => {
  return {
    type: GET_FILTERED_JOB_BOARD_CANDIDATES,
    payload: { filters },
  };
};

export const getFilteredJobPortalCandidatesSuccess = (candidates) => {
  return {
    type: GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS,
    payload: { candidates },
  };
};

export const getFilteredJobPortalCandidatesError = (error) => {
  return {
    type: GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR,
    payload: { error },
  };
};

// Bulk Generate Matching Score
export const generateBulkMatchingScore = (jobId, candidateIds) => ({
  type: GENERATE_BULK_MATCHING_SCORE,
  payload: { jobId, candidateIds },
});

export const generateBulkMatchingScoreSuccess = (data) => ({
  type: GENERATE_BULK_MATCHING_SCORE_SUCCESS,
  payload: data,
});

export const generateBulkMatchingScoreError = (error) => ({
  type: GENERATE_BULK_MATCHING_SCORE_ERROR,
  payload: error,
});
